const COOKIE_POPUP_ID = 'cookieModal';

let cookiePopup;

function cookieConsent() {
    cookiePopup = document.getElementById(COOKIE_POPUP_ID);

    if (cookiePopup) {
        init();
    }
}

function init() {
    const cookieConsentBtnOk = document.getElementById('cwa-cookie-consent__btn-ok');
    const cookieConsentBtnSave = document.getElementById('cwa-cookie-consent__btn-save');
    const cookieConsentBtnSaveAll = document.getElementById('cwa-cookie-consent__btn-saveAll');
    const cookieConsentBtnSaveNone = document.getElementById('cwa-cookie-consent__btn-saveNone');
    const cookieConsentBtnAll = document.getElementById('cwa-cookie-consent__btn-all');
    var value;
    var cookie;


    $('#cookieModal.autoload').each(function() {
        $('#cookieModal').modal('show');
    });


    $('#cookieModal').on('shown.bs.modal', function () {
      $('#cookieButton').removeClass('on');
    })

    $('#cookieModal').on('hidden.bs.modal', function () {
      $('#cookieButton').addClass('on');
    })

    if (cookieConsentBtnAll) {
        cookieConsentBtnAll.addEventListener('click', (event) => {
            console.log("Cookie: save");
            event.preventDefault();
            $('.cwa-cookie-consent__category-group input[type=\'checkbox\']').each(function(i){
                cookie = $(this).attr('data-cookie');
                setItem(cookie, true, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            });
            cookie = $('.cwa-cookie-consent__form').attr('data-cookie');
            setItem(cookie, true, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            $('#cookieModal').modal('hide')
        });
    }

    if (cookieConsentBtnSave) {
        cookieConsentBtnSave.addEventListener('click', (event) => {
            console.log("Cookie: save");
            event.preventDefault();
            $('.cwa-cookie-consent__category-group input[type=\'checkbox\']').each(function(i){
                value  = $(this).prop('checked');
                cookie = $(this).attr('data-cookie');
                setItem(cookie, value, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            });
            cookie = $('.cwa-cookie-consent__form').attr('data-cookie');
            setItem(cookie, true, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            $('#cookieModal').modal('hide')
        });
    }

    if (cookieConsentBtnSaveAll) {
        cookieConsentBtnSaveAll.addEventListener('click', (event) => {
            console.log("Cookie: save all");
            event.preventDefault();
            $('.cwa-cookie-consent__category-group input[type=\'checkbox\']').each(function(i){
                cookie = $(this).attr('data-cookie');
                if (cookie != "Cookie_Category_system_1") {
                    $(this).prop('checked', true);
                }
                setItem(cookie, true, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            });
            cookie = $('.cwa-cookie-consent__form').attr('data-cookie');
            setItem(cookie, true, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            $('#cookieModal').modal('hide')
        });
    }
    if (cookieConsentBtnSaveNone) {
        cookieConsentBtnSaveNone.addEventListener('click', (event) => {
            console.log("Cookie: save none");
            event.preventDefault();

            $('.cwa-cookie-consent__category-group input[type=\'checkbox\']').each(function(i){
                cookie = $(this).attr('data-cookie');
                value = true;
                if (cookie !== "Cookie_Category_system_1") {
                    value = false;
                    $(this).prop('checked', false);
                }
                setItem(cookie, value, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            });
            cookie = $('.cwa-cookie-consent__form').attr('data-cookie');
            setItem(cookie, true, "Fri, 31 Dec 9999 23:59:59 GMT", '/', '' )
            $('#cookieModal').modal('hide')
        });
    }
}


function getItem(sKey) {
    if (!sKey) { return null; }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}

function setItem (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    console.log('Cookie: setItem(' + sKey + ',' + sValue + ',' + vEnd + ',' + sPath + ',' + sDomain + ',' + bSecure + ')');
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
        switch (vEnd.constructor) {
            case Number:
                sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                break;
            case String:
                sExpires = "; expires=" + vEnd;
                break;
            case Date:
                sExpires = "; expires=" + vEnd.toUTCString();
                break;
        }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
}

function removeItem(sKey, sPath, sDomain) {
    if (!hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
}

function hasItem(sKey) {
    if (!sKey) { return false; }
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
}

function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
}
export default cookieConsent;
